// extracted by mini-css-extract-plugin
module.exports = {"pagination-container":"Pagination_pagination-container__LuzPD","page-number":"Pagination_page-number__HSbPz","active":"Pagination_active__kHK4K"};